var zigzag = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/zigzag.jpg';
var zigzagDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/zigzagDetail1.jpg';
var handstand = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/handstand.jpg';
var handstandDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/handstandDetail1.jpg';
var archway = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/archway.jpg';
var arch = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/arch.jpg';
var archDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/archDetail1.jpg';
var arc = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/arc.jpg';
var eddy = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/eddy.jpg';
var propeller = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/propeller.jpg';
var propellerDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-ls/propellerDetail1.jpg';

export const allImagesDesktopOrderLs = [
    [/*COLUMN 1*/
        [
            {
                name: zigzag,
                artistName: "Lorraine Shemesh",
                title: "Zig Zag",
                year: "2003",
                dimensions: "83 1/2 x 52 3/4 in., o/c",
                link: "ls1",
                privateCollection: "Private Collection"
            },
            {
                name: zigzagDetail1,
                artistName: "Lorraine Shemesh",
                title: "Zig Zag - detail",
                year: "2003",
                dimensions: "83 1/2 x 52 3/4 in., o/c",
                link: "ls2",
                privateCollection: "Private Collection"

            }
        ],
        [
            {
                name: handstand,
                artistName: "Lorraine Shemesh",
                title: "Hand Stand",
                year: "2003",
                dimensions: "83 1/4 x 39 1/4 in., o/c",
                link: "ls3",
                privateCollection: "Private Collection"
            },
            {
                name: handstandDetail1,
                artistName: "Lorraine Shemesh",
                title: "Hand Stand - detail",
                year: "2003",
                dimensions: "83 1/4 x 39 1/4 in., o/c",
                link: "ls4",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {    
                name: archway,
                artistName: "Lorraine Shemesh",
                title: "Archway",
                year: "2001",
                dimensions: "81 3/8 x 51 5/8 in., o/c",
                link: "ls5",
                privateCollection: ""
            }
        ],
        [
            {
                name: propeller,
                artistName: "Lorraine Shemesh",
                title: "Propeller",
                year: "2002",
                dimensions: "67 1/2 x 71 1/2 in., o/c",
                link: "ls11",
                privateCollection: "Private Collection"
            },
            {
                name: propellerDetail1,
                artistName: "Lorraine Shemesh",
                title: "Propeller - detail",
                year: "2002",
                dimensions: "67 1/2 x 71 1/2 in., o/c",
                link: "ls12",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: arc,
                artistName: "Lorraine Shemesh",
                title: "Arc",
                year: "2001",
                dimensions: "76 7/8 x 62 3/4 in. o/c",
                link: "ls9",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: eddy,
                artistName: "Lorraine Shemesh",
                title: "Eddy",
                year: "2003",
                dimensions: "66 1/2 x 66 in., o/c",
                link: "ls10",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: arch,
                artistName: "Lorraine Shemesh",
                title: "Arch",
                year: "2001",
                dimensions: "80 x 57 3/4 in., o/c",
                link: "ls7",
                privateCollection: "Collection Novartis Corporation, Basel, Switzerland"
            },
            {
                name: archDetail1,
                artistName: "Lorraine Shemesh",
                title: "Arch - detail",
                year: "2001",
                dimensions: "80 x 57 3/4 in., o/c",
                link: "ls8",
                privateCollection: "Collection Novartis Corporation, Basel, Switzerland"

            }
        ]
    ]          
]

export const allImagesMobileOrderLs = [
    [{
        name: zigzag,
        artistName: "Lorraine Shemesh",
        title: "Zig Zag",
        year: "2003",
        dimensions: "83 1/2 x 52 3/4 in., o/c",
        link: "ls1",
        privateCollection: "Private Collection"
    },
    {
        name: zigzagDetail1,
        artistName: "Lorraine Shemesh",
        title: "Zig Zag - detail",
        year: "2003",
        dimensions: "83 1/2 x 52 3/4 in., o/c",
        link: "ls2",
        privateCollection: "Private Collection"
    },
    {
        name: handstand,
        artistName: "Lorraine Shemesh",
        title: "Hand Stand",
        year: "2003",
        dimensions: "83 1/4 x 39 1/4 in., o/c",
        link: "ls3",
        privateCollection: "Private Collection"
    },
    {
        name: handstandDetail1,
        artistName: "Lorraine Shemesh",
        title: "Hand Stand - detail",
        year: "2003",
        dimensions: "83 1/4 x 39 1/4 in., o/c",
        link: "ls4",
        privateCollection: "Private Collection"
    },
    {    
        name: archway,
        artistName: "Lorraine Shemesh",
        title: "Archway",
        year: "2001",
        dimensions: "81 3/8 x 51 5/8 in., o/c",
        link: "ls5",
        privateCollection: ""
    },
    {
        name: arch,
        artistName: "Lorraine Shemesh",
        title: "Arch",
        year: "2001",
        dimensions: "80 x 57 3/4 in., o/c",
        link: "ls7",
        privateCollection: "Collection Novartis Corporation, Basel, Switzerland"
    },
    {
        name: archDetail1,
        artistName: "Lorraine Shemesh",
        title: "Arch - detail",
        year: "2001",
        dimensions: "80 x 57 3/4 in., o/c",
        link: "ls8",
        privateCollection: "Collection Novartis Corporation, Basel, Switzerland"
    },
    {
        name: arc,
        artistName: "Lorraine Shemesh",
        title: "Arc",
        year: "2001",
        dimensions: "76 7/8 x 62 3/4 in. o/c",
        link: "ls9",
        privateCollection: ""
    },
    {
        name: eddy,
        artistName: "Lorraine Shemesh",
        title: "Eddy",
        year: "2003",
        dimensions: "66 1/2 x 66 in., o/c",
        link: "ls10",
        privateCollection: "Private Collection"
    },
    {
        name: propeller,
        artistName: "Lorraine Shemesh",
        title: "Propeller",
        year: "2002",
        dimensions: "67 1/2 x 71 1/2 in., o/c",
        link: "ls11",
        privateCollection: "Private Collection"
    },
    {
        name: propellerDetail1,
        artistName: "Lorraine Shemesh",
        title: "Propeller - detail",
        year: "2002",
        dimensions: "67 1/2 x 71 1/2 in., o/c",
        link: "ls12",
        privateCollection: "Private Collection"
    }]      
]
